<template>
  <div class="page">
    <div class="page-content container-fluid page-dashboard">
      <div class="row" v-if="showMainCurrentState && showMonthlyPricingPlan">
        <div class="col-lg-7 col-md-12 col-xs-12">
          <main-current-state
            v-bind:team="team"
            v-bind:forceFullWidthBoxes="true"
            v-if="showMainCurrentState"
          ></main-current-state>
        </div>
        <div class="col-lg-5 col-md-12 col-xs-12" v-if="showMonthlyPricingPlan">
          <div class="page-header p-r-0">
            <h1 class="page-title">{{ $t("pricingPlan.title") }}
              <a href="https://www.byteark.com/pricing-2015" v-if="showPricingPlan2015" class="btn btn-link p-r-0 pull-xs-right" target="_blank">
                {{ $t("action.moreDetail") }}<i class="icon md-chevron-right m-r-0" aria-hidden="true"></i>
              </a>
              <a href="https://www.byteark.com/pricing/" v-else class="btn btn-link p-r-0 pull-xs-right" target="_blank">
               {{ $t("action.moreDetail") }}<i class="icon md-chevron-right m-r-0" aria-hidden="true"></i>
              </a>
            </h1>
          </div>
          <year-2015-pricing-plan v-if="showPricingPlan2015"></year-2015-pricing-plan>
          <year-2017-pricing-plan v-else></year-2017-pricing-plan>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 col-md-12 col-xs-12">
          <div class="page-header">
            <h1 class="page-title">{{ $t("mainHeaderGroups.solutions") }}</h1>
          </div>
          <div class="row">
            <div class="col-md-12 col-xs-12">
              <a v-bind:href="serviceS3URL" class="non-link" :title="$t('solutions.fileDistributor.name')" target="_blank">
                <div class="bg-white p-35 clearfix m-b-30 service-box file-distributor-box">
                  <div class="counter counter-md counter detail text-xs-left pull-xs-left">
                    <div class="counter-number-group">
                      <span class="counter-number text-primary">{{ $t("solutions.fileDistributor.name") }}</span>
                    </div>
                    <div class="counter-label font-size-14">
                      <p class="m-b-10 m-t-10">{{ $t("solutions.fileDistributor.shortDescription") }}</p>
                      <span class="blue-600">Start with {{ $t("services.storage.name") }}  <i class="icon md-chevron-right" aria-hidden="true"></i></span>
                    </div>
                  </div>
                  <!--div class="card-watermark darker font-size-60 m-15">
                    <i class="icon md-storage" aria-hidden="true"></i>
                  </div-->
                  <div class="pull-xs-right white m-t-10">
                    <i class="icon icon-circle icon-2x md-storage bg-primary"></i>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-md-12 col-xs-12">
              <a v-bind:href="serviceQoderURL" class="non-link" :title="$t('solutions.vod.name')" target="_blank">
                <div class="bg-white p-35 clearfix m-b-30 service-box vod-box">
                  <div class="counter counter-md counter detail text-xs-left pull-xs-left">
                    <div class="counter-number-group">
                      <span class="counter-number text-primary">{{ $t("solutions.vod.name") }}</span>
                    </div>
                    <div class="counter-label font-size-14">
                      <p class="m-b-10 m-t-10">{{ $t("solutions.vod.shortDescription") }}</p>
                      <span class="blue-600">Start with {{ $t("services.qoder.name") }} <i class="icon md-chevron-right" aria-hidden="true"></i></span>
                    </div>
                  </div>
                  <!--div class="card-watermark darker font-size-60 m-15">
                    <i class="icon md-videocam" aria-hidden="true"></i>
                  </div-->
                  <div class="pull-xs-right white m-t-10">
                    <i class="icon icon-circle icon-2x md-videocam bg-primary"></i>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-md-12 col-xs-12">
              <a v-bind:href="serviceFleetURL" class="non-link" :title="$t('solutions.liveStraming.name')" target="_blank">
                <div class="bg-white p-35 clearfix m-b-30 service-box">
                  <div class="counter counter-md counter detail text-xs-left pull-xs-left">
                    <div class="counter-number-group">
                      <span class="counter-number text-primary">{{ $t("solutions.liveStraming.name") }}</span>
                    </div>
                    <div class="counter-label font-size-14">
                      <p class="m-b-10 m-t-10">{{ $t("solutions.liveStraming.shortDescription") }}</p>
                      <span class="blue-600">Start with {{ $t("services.fleet.name") }} <i class="icon md-chevron-right" aria-hidden="true"></i></span>
                    </div>
                  </div>
                  <!--div class="card-watermark darker font-size-60 m-15">
                    <i class="icon md-swap-vertical" aria-hidden="true"></i>
                  </div-->
                  <div class="pull-xs-right white m-t-10">
                    <i class="icon icon-circle icon-2x md-swap-vertical bg-primary"></i>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-md-12 col-xs-12">
              <a v-bind:href="serviceFleetURL" class="non-link" :title="$t('solutions.webCDN.name')" target="_blank">
                <div class="bg-white p-35 clearfix m-b-30 service-box">
                  <div class="counter counter-md counter detail text-xs-left pull-xs-left">
                    <div class="counter-number-group">
                      <span class="counter-number text-primary">{{ $t("solutions.webCDN.name") }}</span>
                    </div>
                    <div class="counter-label font-size-14">
                      <p class="m-b-10 m-t-10">{{ $t("solutions.webCDN.shortDescription") }}</p>
                      <span class="blue-600">Start with {{ $t("services.fleet.name") }} <i class="icon md-chevron-right" aria-hidden="true"></i></span>
                    </div>
                  </div>
                  <!--div class="card-watermark darker font-size-60 m-15">
                    <i class="icon md-laptop" aria-hidden="true"></i>
                  </div-->
                  <div class="pull-xs-right white m-t-10">
                    <i class="icon icon-circle icon-2x md-laptop bg-primary"></i>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-12 col-xs-12">
          <div class="page-header">
            <h1 class="page-title">{{ $t("mainHeaderGroups.quickStart") }}</h1>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="list-group bg-white bg-inherit">
                <a href="http://docs.byteark.com/article/http-live-streaming/" class="list-group-item text-primary">
                  {{ $t("quickStart.howToLiveStream.name") }}
                  <span class="pull-xs-right"><i class="icon md-chevron-right" aria-hidden="true"></i></span>
                </a>
                <a href="http://docs.byteark.com/article/getting-start/vod-streaming" class="list-group-item text-primary">
                  {{ $t("quickStart.howToUploadVdo.name") }}
                  <span class="pull-xs-right"><i class="icon md-chevron-right" aria-hidden="true"></i></span>
                </a>
                <a href="http://docs.byteark.com/article/byteark-storage/" class="list-group-item text-primary">
                  {{ $t("quickStart.howToUploadFileToCDN.name") }}
                  <span class="pull-xs-right"><i class="icon md-chevron-right" aria-hidden="true"></i></span>
                </a>
                <a href="http://docs.byteark.com/article/payment/" class="list-group-item text-primary">
                  {{ $t("quickStart.howToAddCredit.name") }}
                  <span class="pull-xs-right"><i class="icon md-chevron-right" aria-hidden="true"></i></span>
                </a>
                <a href="http://docs.byteark.com/article/getting-start/web-cdn" class="list-group-item text-primary">
                  {{ $t("quickStart.howToImplementCDN.name") }}
                  <span class="pull-xs-right"><i class="icon md-chevron-right" aria-hidden="true"></i></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MainCurrentState from 'components/billings/MainCurrentState';
import Year2015PricingPlan from 'components/billings/pricingPlan/Year2015PricingPlan';
import Year2017PricingPlan from 'components/billings/pricingPlan/Year2017PricingPlan';

export default {
  components: {
    MainCurrentState,
    Year2015PricingPlan,
    Year2017PricingPlan,
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    isLoading: function() {
      return this.isCurrentStatLoading;
    },
    showMainCurrentState: function () {
      if (this.team) {
        if (this.team.is_superadmin || this.team.has_reseller) {
          return false;
        }
      }

      if (this.currentUser.role === 'user') {
        return false;
      }

      return true;
    },
    showMonthlyPricingPlan: function () {
      if (this.team) {
        if (this.team.is_superadmin || this.team.has_reseller) {
          return false;
        }
      }

      if (this.currentUser.role === 'user') {
        return false;
      }

      return true;
    },
    team: function() {
      if (this.currentUser) {
        return this.currentUser.team;
      }
      return null;
    },
    serviceS3URL: function() {
      if (this.currentUser) {
        const namespace = this.currentUser.team.namespace;
        return `${process.env.SERVICES.S3}${namespace}`;
      }
      return null;
    },
    serviceQoderURL: function() {
      if (this.currentUser) {
        const namespace = this.currentUser.team.namespace;
        return `${process.env.SERVICES.QODER}/${namespace}`;
      }
      return null;
    },
    serviceFleetURL: function() {
      if (this.currentUser) {
        const namespace = this.currentUser.team.namespace;
        return `${process.env.SERVICES.FLEET}/${namespace}`;
      }
      return null;
    },
  },
  data: function () {
    return {
      showCurrentStat: false,
      isCurrentStatLoading: false,
      showPricingPlan2015: false,
    };
  },
  created: function() {
    if (this.team) {
      this.showPricingPlan2015 = (this.team.pricing_plan === 'year_2015') ? 1 : 0;
    }
  },
  mounted: function() {
    this.checkVisibleComponents();
  },
  methods: {
    checkVisibleComponents: function() {
      if (!this.team.is_reseller && !this.team.has_reseller) {
        // team is normal user
        const isTeamManager = (this.currentUser.role === 'manager');

        if (isTeamManager) {
          this.showCurrentStat = true;
        }
      } else if (this.team.is_reseller) {
        // team is reseller
        this.showCurrentStat = true;
      } else if (this.team.has_reseller) {
        // team is reseller client
      }
    },
    currentStatLoadChanged: function(value) {
      this.isCurrentStatLoading = value;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Home.vue?7faae2dd